module.exports = __webpack_public_path__ + "img/img-2e354b.png";